import React from 'react';
import { matchPath } from 'react-router-dom';
import _get from 'lodash/get';
import { PersistGate } from 'redux-persist/integration/react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import Root from './components/RootCategoryPageMobile';
import configureStore from './store/categoryPageStore';
import { getMobileChunk } from './asyncImportList';
import getWebpackPublicPath from './utils/commonUtils';
import MobileShellRoutes from './config/mobileshellRoutes';
import './ajio-styles/root.pcss';
import entryPointSetup from './refresh/utils/entryPointUtils';
import { init } from './utils/dataGrinch';
import { getParams } from './utils/pageInfo';
import "./instrument.js";
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => import('./web-vitals-integration'), { timeout: 5000 });
  requestIdleCallback(() => import('./initializeCopilot'), { timeout: 5000 });
} else {
  setTimeout(() => import('./web-vitals-integration'), 5000);
  setTimeout(() => import('./initializeCopilot'), 5000);
}

const preloadedState = window.__PRELOADED_STATE__;
__webpack_public_path__ = getWebpackPublicPath();

const { store, persistor } = configureStore(preloadedState);

let hasRendered = false;
const render = () => {
  if (hasRendered) return;
  hasRendered = true;
  init(getParams(location)).catch(() => {});
  const container = document.getElementById('app');
  const root = createRoot(container);
  root.render(<Root store={store} persistor={persistor} />);
  if (typeof window.__hideLoader === 'function') window.__hideLoader();
};

const { pathname = '' } = location;
const pathComponent = pathname.split('/');

const asyncComp = getMobileChunk(pathComponent[1]);

if (asyncComp) {
  asyncComp.then(module => {
    window.loadedComponent = module.default;
    if (window.pageType !== 'OFFLINEPAGE') {
      render();
    }
  });
} else if (window.pageType !== 'OFFLINEPAGE') {
  render();
}

// apply only shell pages
const matchedShellUrlConfig = MobileShellRoutes.filter(routeConfig =>
  matchPath(pathname, routeConfig)
);
if (matchedShellUrlConfig && matchedShellUrlConfig.length) {
  const {
    headerConfig = {},
    footerConfig: { isFooter = true, ...restFooterConfig } = {}
  } = matchedShellUrlConfig[0];
  const { showHeader = true, showSisHeader = true } = headerConfig;
  const state = store.getState();
  const isSIS = _get(state, 'metaData.sis', false);
  const headerFlag = isSIS ? showSisHeader : showHeader;
  if (headerFlag) {
    import(/* webpackChunkName: "static/chunk/mobile/Header" */ './components/mobile/header/Header').then(({ default: Header }) => {
      const container = document.getElementById('header-markup');
      const root = createRoot(container);
      root.render(
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Header {...headerConfig} />
          </PersistGate>
        </Provider>
      );
    });
  }
  if (isFooter) {
    import(/* webpackChunkName: "static/chunk/mobile/Footer" */ './components/mobile/footer/Footer').then(({ default: Footer }) => {
      const container = document.getElementById('footer-markup');
      const root = createRoot(container);
      root.render(
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Footer {...restFooterConfig} />
          </PersistGate>
        </Provider>
      );
    });
  }
}

if (window.pageType !== 'OFFLINEPAGE') {
  render();
}

entryPointSetup();
